import { navigate, type Screen } from '@/app'
import { clear, el } from '@/lib/dom'
import { T } from '@/lib/i18n'
import { getLiveNow, getLiveSchedule, type LiveNow, type LiveProgram } from '@/lib/live'
import { webButton, webEmpty, webPage, webScreen, webTitle } from '@/browser/ui'

/**
 * «Canlı» — xətti kanal, brauzer variantı.
 *
 * ⚠ CİHAZ EKRANINDAN BİR DAVRANIŞ FƏRQİ VAR VƏ QƏSDƏNDİR: orada yayım gedirsə
 *   ekran BİRBAŞA player-ə keçir («Bax» addımı yoxdur — sahib tələbi). Brauzerdə
 *   isə avtomatik tam ekran + səs BRAUZER SİYASƏTİNƏ TAKILIR: `requestFullscreen`
 *   və səsli `play()` yalnız istifadəçi jestinin zəncirində icazəlidir. Avtomatik
 *   keçsək player səssiz/tam-ekransız açılar və istifadəçi «işləmir» sanar. Ona
 *   görə burada AÇIQ «Bax» düyməsi qalır — jest məhz o kliklə gəlir.
 * ⚠ Poll 15 saniyədir və YALNIZ proqram dəyişəndə DOM-a toxunur.
 */
const POLL_MS = 15000

export function createWebLiveScreen(): Screen {
  const page = webPage()
  page.appendChild(webTitle(T('Canlı')))

  const body = el('div')
  body.appendChild(webEmpty(T('Yüklənir…')))
  page.appendChild(body)

  let destroyed = false
  let pollTimer = 0
  let lastKey = ''

  function keyFor(now: LiveNow | null): string {
    if (!now || !now.isActive) return now && now.next ? 'gap:' + now.next.id : 'gap'
    return now.current ? 'live:' + now.current.id : 'gap'
  }

  function hhmm(iso: string): string {
    const date = new Date(iso)
    const two = (value: number): string => (value < 10 ? '0' + value : '' + value)
    return two(date.getHours()) + ':' + two(date.getMinutes())
  }

  function render(now: LiveNow | null, schedule: LiveProgram[]): void {
    clear(body)
    const current = now && now.isActive ? now.current : null

    if (!current) {
      body.appendChild(webEmpty(T('Yayım yoxdur')))
      if (now && now.next) {
        body.appendChild(webEmpty(T('Növbəti: ') + now.next.title + ' · ' + hhmm(now.next.startsAt)))
      }
      return
    }

    const head = el('div')
    head.appendChild(el('h2', 'web-detail__title', current.title))
    // ⚠ Cihaz ekranındakı eyni düzəliş (2026-08-30): açar lüğətdə vardı, çağırış
    //   yeri isə çılpaq sətir yazırdı.
    let sub = T('● CANLI')
    if (now && now.next) sub += T(' · Növbəti: ') + now.next.title + ' · ' + hhmm(now.next.startsAt)
    head.appendChild(el('p', 'web-detail__meta', sub))
    head.appendChild(
      webButton(T('▶  Bax'), () =>
        navigate({
          name: 'player',
          slug: current.contentSlug || current.contentId,
          title: current.title,
          live: true,
          liveProgramId: current.id,
        }),
      ),
    )
    body.appendChild(head)

    if (schedule.length) {
      const list = el('div')
      list.style.marginTop = '26px'
      list.appendChild(el('h2', 'web-row__title', T('Bu günün proqramı')))
      for (let i = 0; i < schedule.length && i < 12; i++) {
        const program = schedule[i]
        if (!program) continue
        const row = el('div', 'web-list__item')
        row.appendChild(document.createTextNode(hhmm(program.startsAt) + '  ·  ' + program.title))
        if (program.isLive) row.appendChild(el('span', 'web-list__value', T('CANLI')))
        list.appendChild(row)
      }
      body.appendChild(list)
    }
  }

  function load(): void {
    void Promise.all([getLiveNow(), getLiveSchedule()]).then((pair) => {
      if (destroyed) return
      const now = pair[0]
      const key = keyFor(now)
      if (key !== lastKey) {
        lastKey = key
        render(now, pair[1])
      }
      pollTimer = window.setTimeout(load, POLL_MS)
    })
  }
  load()

  return webScreen(page, () => {
    destroyed = true
    if (pollTimer) window.clearTimeout(pollTimer)
  })
}
